import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Who,
  Benefits,
  Metrics,
  Values,
  Pricing,
  AreYouReady,
} from './components';

const LandingMediaKitPedroConLasMascotas = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Who themeMode={themeMode} />
      </Container>
      {/* Opcional: agregar iframe de video cuando tengan URL
      <Container>
        <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: isSm ? 4 : 0, boxShadow: 3 }}>
          <Box component="iframe" src="..." ... />
        </Box>
      </Container>
      */}
      <Container>
        <Benefits />
      </Container>
      <Container>
        <Metrics />
      </Container>
      <Container>
        <Values />
      </Container>
      <Container>
        <Pricing />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitPedroConLasMascotas.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default LandingMediaKitPedroConLasMascotas;
